import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import AgenciesTable from '../AgenciesTable';
import ModalEditar from '../Modals/ModalEditar';
import { useMaxDailyAmount } from '../CustomHooks/useMaxDailyAmount';
import { useCurrencyFormatter } from '../CustomHooks/useCurrencyFormatter';

const MaxDiarioTab = () => {
  const agencySelected = useSelector((state) => state.myAgencies?.selected_agencie_to_consult);
  const agencies = useSelector((state) => state?.myAgencies?.user_agencies);
  
  const { pdvs, loading, fetchMaxDailyAmount, updateMaxDailyAmount } = useMaxDailyAmount(agencySelected, agencies);
  const { formattedAmount, rawAmount, helperText, handleAmountChange, reset } = useCurrencyFormatter();
  
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedAgency, setSelectedAgency] = useState(null);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (agencySelected.agencyLevel === "CONCENTRATOR") {
      fetchMaxDailyAmount();
    } else {
      setMessage("❌ UD. NO TIENE ACCESO A ESTA FUNCIONALIDAD.");
    }
  }, [agencySelected, fetchMaxDailyAmount]);

  const handleEdit = (agency) => {
    setSelectedAgency(agency);
    setOpenEditModal(true);
  };

  const handleSave = async () => {
    const success = await updateMaxDailyAmount({
      ...selectedAgency,
      newAmount: rawAmount,
    });
    
    if (success) {
      setOpenEditModal(false);
      reset();
    }
  };

  return (
    <>
      <Grid item xs={12} md={12}>
        <AgenciesTable
          agencies={pdvs || []}
          handleEdit={handleEdit}
          message={message}
          loading={loading}
        />
      </Grid>
      
      <ModalEditar
        open={openEditModal}
        setOpen={setOpenEditModal}
        agency={selectedAgency}
        handleSetAmountReceived={handleAmountChange}
        formattedAmountReceived={formattedAmount}
        updateMaxDailyAmountByPdv={handleSave}
        newMaxAmount={rawAmount}
        helperTextMessage={helperText}
      />
    </>
  );
};

export default MaxDiarioTab;